// image-processing-loader
var previousRequest = require("!!../../../../../node_modules/fox-file-loader/index.js!../../../../../node_modules/file-loader/index.js?name=[path][name].[ext]!./slideshow_gray.png");
var dir = previousRequest.replace("slideshow_gray.png", "")
module.exports = require("!../../../../../node_modules/fox-image-optimize-plugin/router.js")({
	dir: dir,
	base: "slideshow_gray.png",
	name: "slideshow_gray",
	ext: ".png",
	query: ""
}, previousRequest);


//////////////////
// WEBPACK FOOTER
// ./images/slideshow_gray.png
// module id = 1113
// module chunks = 4